<template>
    <div class="sidebar-container">
        <div class="instance-title-container">
            <v-btn
                :color="instance.application.color"
                class="sidebar-square-instance"
            >
                <div class="instance-btn-content" style="text-transform: lowercase;">
                    v{{ instance.current_modelisation.version }}
                </div>
            </v-btn>
            <span class="instance-label">
                {{instance.label}}
            </span>
        </div>
        <div class="sidebar-details-title">
            {{$t('instance.instance_details.instance_side_bar.side_bar_title')}}
        </div>
        <div
            v-for="(sideBarEntry, index) in sideBarEntries"
            :key="index"
        >
            <div
                class="sidebar-entries-button"
                @click="$emit('changeCurrentView', index)"
            >
                {{sideBarEntry}}
            </div>
        </div>
    </div>
</template>

<script>
export default {

    name: 'instance-side-bar',

    props:{
        instance:{
            type: Object,
            required: true,
        },
    },

    data () {
        return {
        };
    },
    computed:{
        sideBarEntries(){
            return [
                this.$t('instance.instance_details.instance_side_bar.general_entry'),
                this.$t('instance.instance_details.instance_side_bar.administrator_entry'),
                this.$t('instance.instance_details.instance_side_bar.parameters_entry'),
            ];
        }
    }
};
</script>

<style lang="css" scoped>
.sidebar-container{
    height: 100vh;
    padding-left: 0;
    box-shadow: 0px 10px 5px #424242;

}
.instance-btn-content {
    transform: rotateZ(-45deg);
    font-size: 13px;
    font-weight: 400;
}
.sidebar-square-instance{
    width: 40px !important;
    min-width: 40px !important;
    max-width: 40px;
    height: 40px !important;
    border-radius: 0;
    pointer-events: none;
    transform: rotateZ(45deg);
}
.instance-label{
    font-size: 14px;
    margin-left:  1.5em;
}
.instance-title-container{
    padding-left: 1em;
}
.sidebar-entries-button{
    cursor: pointer;
    padding: 1em 1em 1em 1em;

}
.sidebar-details-title{
    color: #C7C6C6;
    font-weight: 700;
    padding-left: 1em;
    margin-top: 2.5em;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Instance/InstanceDetails/instance-side-bar.vue